export enum ColourType {
  red = "red",
  amber = "amber",
  green = "green"
}
